import ExecAPI from 'appRoot/api/api';

export function GetSecretsList()
{
	return ExecAPI("SecretsManagerData/GetSecretsList");
}

export function GetSecretDetail(key)
{
	return ExecAPI("SecretsManagerData/GetSecretDetail", { key });
}

/**
 * Returns one secret's value.  The server records every reveal in the user activity log, and refuses write-only secrets.
 * @param {String} key Secret key.
 */
export function RevealSecret(key)
{
	return ExecAPI("SecretsManagerData/RevealSecret", { key });
}

/**
 * Creates or edits a secret.  See SaveSecretRequest in Controllers/SecretsManagerData.cs.
 * @param {Object} request { oldKey ("" to create), key, setValue, value, description, scopeKind, scopeAgentIds, writeOnly, removeFromAgentsLeavingScope }.
 * Null fields keep the stored values.  If the response has needsConfirmation, nothing was saved: re-submit the same request with removeFromAgentsLeavingScope true or false.
 */
export function SaveSecret(request)
{
	return ExecAPI("SecretsManagerData/SaveSecret", request);
}

/**
 * Asks sync to delete the secret from agents outside its scope.
 * @param {String} key Secret key.
 * @param {String[]} agentIds Ids of agents outside the secret's scope.
 */
export function RequestRemoval(key, agentIds)
{
	return ExecAPI("SecretsManagerData/RequestRemoval", { key, agentIds });
}

export function DeleteSecret(key)
{
	return ExecAPI("SecretsManagerData/DeleteSecret", { key });
}

export function GetAgentAuthorization()
{
	return ExecAPI("SecretsManagerData/GetAgentAuthorization");
}

export function SetAgentAuthorization(agentId, authorized)
{
	return ExecAPI("SecretsManagerData/SetAgentAuthorization", { agentId, authorized });
}

export function DownloadSecretsJson()
{
	return ExecAPI("SecretsManagerData/DownloadSecretsJson");
}
